import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';

import { type DefaultVendorTypes } from '../../accounting/vendor';

type Payload = {
  id: string;
  type: DefaultVendorTypes;
};

export const useSetDefaultVendorMutation = (): MutationState<Payload> => {
  return useMutation<Payload>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      method: 'put',
      endpoint: '/accounting-integration/supplier-sync/default',
    },
    options: {
      onSuccess({ client }): void {
        client.invalidateQueries('useGetDefaultVendorsQuery');
      },
    },
  });
};
